"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalApiRpcLocal = void 0;
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
const identifiers_1 = require("../identifiers");
class ExternalApiRpcLocal {
    options;
    constructor(options) {
        this.options = options;
    }
    async externalFetchData(request, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const result = await this.options.executeRecursiveOperation((0, identifiers_1.toDhtAddress)(request.key), DhtRpc_1.RecursiveOperation.FETCH_DATA, (0, identifiers_1.toNodeId)(senderPeerDescriptor));
        return DhtRpc_1.ExternalFetchDataResponse.create({ entries: result.dataEntries ?? [] });
    }
    async externalStoreData(request, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const result = await this.options.storeDataToDht((0, identifiers_1.toDhtAddress)(request.key), request.data, (0, identifiers_1.toNodeId)(senderPeerDescriptor));
        return DhtRpc_1.ExternalStoreDataResponse.create({
            storers: result
        });
    }
    async externalFindClosestNodes(request, context) {
        const senderPeerDescriptor = context.incomingSourceDescriptor;
        const result = await this.options.executeRecursiveOperation((0, identifiers_1.toDhtAddress)(request.nodeId), DhtRpc_1.RecursiveOperation.FIND_CLOSEST_NODES, (0, identifiers_1.toNodeId)(senderPeerDescriptor));
        return DhtRpc_1.ExternalFindClosestNodesResponse.create({
            closestNodes: result.closestNodes
        });
    }
}
exports.ExternalApiRpcLocal = ExternalApiRpcLocal;
//# sourceMappingURL=ExternalApiRpcLocal.js.map